import { render, staticRenderFns } from "./IconLogoStampDots.vue?vue&type=template&id=729015ba&scoped=true&"
var script = {}
import style0 from "./IconLogoStampDots.vue?vue&type=style&index=0&id=729015ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729015ba",
  null
  
)

export default component.exports